import {
    NEW_CAMPO_CADASTRO_SUCCESS,
    CANCEL_CAMPO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_CAMPO_CADASTRO_PENDING,
    TABLE_CAMPO_CADASTRO_SUCCESS,
    TABLE_CAMPO_CADASTRO_FAILURE,
    LIST_CAMPO_CADASTRO_PENDING,
    LIST_CAMPO_CADASTRO_SUCCESS,
    LIST_CAMPO_CADASTRO_FAILURE,
    FIND_CAMPO_CADASTRO_PENDING,
    FIND_CAMPO_CADASTRO_SUCCESS,
    FIND_CAMPO_CADASTRO_FAILURE,
    DELETE_CAMPO_CADASTRO_PENDING,
    DELETE_CAMPO_CADASTRO_SUCCESS,
    DELETE_CAMPO_CADASTRO_FAILURE,
    CREATE_CAMPO_CADASTRO_PENDING,
    CREATE_CAMPO_CADASTRO_SUCCESS,
    CREATE_CAMPO_CADASTRO_FAILURE,
    NEW_CAMPO_CADASTRO_PENDING,
} from './actionTypes';


const initialState = { list: null, loading: false }


function campoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CAMPO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case NEW_CAMPO_CADASTRO_PENDING:
        case LIST_CAMPO_CADASTRO_PENDING:
        case FIND_CAMPO_CADASTRO_PENDING:
        case DELETE_CAMPO_CADASTRO_PENDING:
        case CREATE_CAMPO_CADASTRO_PENDING:
        case TABLE_CAMPO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_CAMPO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CAMPO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_CAMPO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_CAMPO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_CAMPO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CAMPO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CAMPO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CAMPO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CAMPO_CADASTRO_SUCCESS:
        case CREATE_CAMPO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_CAMPO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { campoCadastroReducer };